export default __webpack_public_path__ + "static/media/app-logo.77b02f05.svg";